import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import TextBox from '../Generales/TextBox';
import { faLaptopHouse } from '@fortawesome/free-solid-svg-icons';

class InputDialog extends React.Component {
  render() {
    const { isOpen, toggle, email, onConfirm, setEmail, titulo, error } = this.props;


    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{titulo}</ModalHeader>
        <ModalBody>
          {'Por favor, introduzca una dirección de correo electrónico para continuar'}
          <br/>
          <br/>

          <TextBox
            id={'email'}
            type={'texzt'}
            disabled={false}
            value={email}
            name={'email'}
            hasError={faLaptopHouse}
            esDependiente={false}
            mensajeError={'Ingrese un correo electrónico válido'}
            placeholder={'Ingrese un correo electrónico'}
            validacionYup={true}
            mensajeErrorYup={error}
            validationCallback={()=>{}}
            onChange={(valor) => {

              setEmail(valor)



            }}
         
          />



        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              onConfirm();
           //   toggle();
            }}
          >
            Enviar
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default InputDialog;
